<template>
  <div>
    <div class="head pt-8 pb-16">
      <div class="wrapper">
        <div class="head-infos">
          <span @click="$emit('go-back', index)" class="mr-6 cursor-pointer">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="white" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.81836 18H28.182" stroke="white" stroke-width="2.90909" stroke-linecap="round"
                    stroke-linejoin="round"/>
              <path d="M15.0911 10.7273L7.81836 18" stroke="white" stroke-width="2.90909" stroke-linecap="round"
                    stroke-linejoin="round"/>
              <path d="M15.0911 25.2727L7.81836 18" stroke="white" stroke-width="2.90909" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </span>
          <div class="progress" :style="{'--width': getProgress}"></div>
          <div class="p-2">
            <router-link :to="{name: 'Home'}">
              <sprite-icon name="home" size="big" color="white"/>
            </router-link>
          </div>
        </div>
        <div class="flex align-items-center space-between mt-6">
          <h2 class="white">{{ $t('capsuleV2.summary.solution') }}</h2>
          <div class="icon-container" style="--icon-container-color: #F6365C;">
            <img src="../../assets/img/idea.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="bubble reverse" :style="{'--head-bg': block.fields.color === 'rouge' ? '#F6365C' : '#63C1A8'}">
      <div class="triangle" :style="{'--head-bg': block.fields.color === 'rouge' ? '#F6365C' : '#63C1A8'}"></div>
    </div>

    <div class="wrapper" style="margin-top: -32px;">
      <h2>{{ block.fields.title }}</h2>
      <p class="mt-3"><b>{{ block.fields.description }}</b></p>

      <div class="video-container my-8">
        <iframe v-if="block.fields.video.includes('vimeo')"
                :src="'https://player.vimeo.com/video/' + block.fields.video.split('/')[3] + '?h=' + block.fields.video.split('/')[4]"
                width="100%"
                height="400px" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        <div v-else>
          <div v-if="$route.query.env" class="container-embed" ref="embed" @mouseout="showArrow = true"
               v-html="video"/>
          <div v-else class="rounded-xl overflow-hidden" ref="embed" @mouseout="showArrow = true">
            <youtube player-width="100%" :player-height="isMobile ? '215' : '350'" :video-id="videoId"></youtube>
          </div>
        </div>
        <div v-if="block.fields.video && block.fields.video.includes('vimeo')"
             :class="showArrow? 'opacity-1 ': 'opacity-0'" style="var(--transition-quick)"
             class="flex flex-col items-center arrow-full-screen mb-6">
          <svg style="transform:translateX(70px);" width="92" height="76" viewBox="0 0 92 76" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M66.7417 27.5052L68.2279 27.7081L68.2279 27.7081L66.7417 27.5052ZM66.9255 26.1587L68.4118 26.3617L68.4173 26.321L68.4206 26.2801L66.9255 26.1587ZM65.8223 8.28689L64.3535 8.59121L64.3535 8.59121L65.8223 8.28689ZM66.0263 4.04391C65.3339 3.58915 64.4039 3.78184 63.9491 4.47429L56.5384 15.7584C56.0837 16.4509 56.2764 17.3809 56.9688 17.8356C57.6613 18.2904 58.5913 18.0977 59.046 17.4052L65.6333 7.37491L75.6637 13.9622C76.3561 14.417 77.2861 14.2243 77.7409 13.5318C78.1956 12.8394 78.0029 11.9094 77.3105 11.4546L66.0263 4.04391ZM62.0709 45.2208L60.6742 44.6739L60.6742 44.6739L62.0709 45.2208ZM63.6165 41.2734L65.0133 41.8203L65.0304 41.7766L65.0447 41.7319L63.6165 41.2734ZM48.0627 62.4522L47.2942 61.164L47.2942 61.164L48.0627 62.4522ZM48.3323 62.2913L49.1007 63.5795L49.1889 63.527L49.269 63.4629L48.3323 62.2913ZM51.1703 60.0223L50.2336 58.8507L50.2336 58.8507L51.1703 60.0223ZM23.9644 70.2489L24.1911 71.7316L24.1911 71.7316L23.9644 70.2489ZM31.7926 68.7302L31.4484 67.2702L31.4484 67.2702L31.7926 68.7302ZM34.3055 68.1378L34.6496 69.5978L34.6602 69.5953L34.6707 69.5927L34.3055 68.1378ZM58.6726 51.7895L57.4193 50.9654L57.4193 50.9654L58.6726 51.7895ZM68.2279 27.7081L68.4118 26.3617L65.4393 25.9558L65.2555 27.3022L68.2279 27.7081ZM67.2911 7.98256L66.6717 4.99338L63.7341 5.60203L64.3535 8.59121L67.2911 7.98256ZM63.4677 45.7677L65.0133 41.8203L62.2198 40.7265L60.6742 44.6739L63.4677 45.7677ZM48.8311 63.7404L49.1007 63.5795L47.5639 61.0031L47.2942 61.164L48.8311 63.7404ZM49.269 63.4629L52.107 61.1939L50.2336 58.8507L47.3956 61.1197L49.269 63.4629ZM16.6149 72.89L24.1911 71.7316L23.7377 68.7661L16.1615 69.9245L16.6149 72.89ZM32.1367 70.1902L34.6496 69.5978L33.9613 66.6779L31.4484 67.2702L32.1367 70.1902ZM24.1911 71.7316C26.8596 71.3236 29.5093 70.8095 32.1367 70.1902L31.4484 67.2702C28.8986 67.8713 26.3272 68.3701 23.7377 68.7661L24.1911 71.7316ZM47.2942 61.164C43.1356 63.6446 38.6367 65.5039 33.9402 66.683L34.6707 69.5927C39.6508 68.3424 44.4214 66.3708 48.8311 63.7404L47.2942 61.164ZM57.4193 50.9654C55.4534 53.9551 53.0284 56.6163 50.2336 58.8507L52.107 61.1939C55.1481 58.7625 57.7868 55.8669 59.9259 52.6136L57.4193 50.9654ZM68.4206 26.2801C68.9175 20.1583 68.5372 13.9968 67.2911 7.98256L64.3535 8.59121C65.5416 14.3256 65.9043 20.2004 65.4305 26.0374L68.4206 26.2801ZM59.9259 52.6136C61.3414 50.461 62.5284 48.1666 63.4677 45.7677L60.6742 44.6739C59.811 46.8785 58.7201 48.9871 57.4193 50.9654L59.9259 52.6136ZM65.0447 41.7319C66.5129 37.1591 67.578 32.4666 68.2279 27.7081L65.2555 27.3022C64.6293 31.8872 63.603 36.4087 62.1883 40.8148L65.0447 41.7319Z"
                fill="black"/>
          </svg>
          <p class="small italic">{{ $t('capsule.problem.help') }}</p>
        </div>
      </div>

      <div ref="content" class="content clear-both" :class="{active: readMore}">
        <ApiRichRenderer :rich-text="block.fields.article.content" text-type="article" :timer="false"/>
      </div>
      <PrimaryButton v-if="!readMore" color="white" @click.native="readMore = true">{{ $t('cards.readMore') }}
      </PrimaryButton>

      <div class="emotions mt-8">
        <h3>{{ $t('capsuleV2.fix.emotions.title') }}</h3>
        <div class="flex flex-col gap-1.5 mt-4">
          <div @click="toggleEmotion(emotion)" class="emotion flex gap-3 align-items-center"
               :class="{selected: selectedEmotions.find(el => el.id === index + 1)}"
               v-for="(emotion, index) in emotions">
            <div class="emotion-icon">
              <img :src="emotion.icon" alt="">
            </div>
            <p>{{ emotion.text }}</p>
          </div>
        </div>
      </div>
      <div class="journal-container mt-6" v-if="pdfPays">
        <div>
          <img src="../../assets/img/Frame-journal.svg" alt="">
          <p class="strong">{{ $t('capsuleV2.fix.printPdfText') }}</p>
        </div>
        <primary-button color="white" @click.native="openShareMenu" class="mb-4">{{
            $t('capsuleV2.fix.print')
          }}
        </primary-button>
      </div>
      <div class="mt-8">
        <img src="../../assets/img/personnage.png" alt="mascotte">
      </div>
    </div>
    <div class="bubble-down">
      <div class="triangle-down"></div>
    </div>
    <div class="footer">
      <div class="wrapper">
        {{ block.fields.mascotText }}
        <primary-button class="mt-8" @click.native="nextStep">{{ block.fields.buttonText }}</primary-button>
      </div>
    </div>


  </div>
</template>

<script>
import PrimaryButton from "@/components/PrimaryButton";
import ApiRichRenderer from "@/components/ApiRichRenderer";
import SpriteIcon from "@/components/SpriteIcon";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Fix",
  components: {SpriteIcon, ApiRichRenderer, PrimaryButton},
  props: {
    block: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    },
    author: {
      type: Object,
      required: true
    },
    pdfPays: {
      type: Object
    }
  },
  data() {
    return {
      readMore: false,
      isMobile: true,
      video: null,
      videoId: null,
      showArrow: true,
      emotions: [
        {
          id: 1,
          name: 'impressed',
          icon: require("@/assets/illus/ça-m'impressionne.png"),
          text: this.$t('capsuleV2.fix.emotions.impressed')
        },
        {
          id: 2,
          name: 'amazed',
          icon: require("@/assets/illus/emerveillé.png"),
          text: this.$t('capsuleV2.fix.emotions.amazed')
        },
        {
          id: 3,
          name: 'happy',
          icon: require('@/assets/illus/heureux.png'),
          text: this.$t('capsuleV2.fix.emotions.happy')
        },
        {
          id: 4,
          name: 'reassured',
          icon: require('@/assets/illus/rassuré.png'),
          text: this.$t('capsuleV2.fix.emotions.reassure')
        },
        {
          id: 5,
          name: 'inspired',
          icon: require('@/assets/illus/inspiré.png'),
          text: this.$t('capsuleV2.fix.emotions.inspire')
        },
        {
          id: 6,
          name: 'nothing',
          icon: require("@/assets/illus/ça-m'est-égal.png"),
          text: this.$t('capsuleV2.fix.emotions.nothing')
        },
      ],
      selectedEmotions: []
    }
  },
  computed: {
    ...mapGetters(['newCapsule', 'currentUser', 'currentBlock']),
    getProgress() {
      return ((this.index + 1) / this.totalSteps) * 100 + '%';
    },
  },
  methods: {
    ...mapActions(['updateBlock']),
    async openShareMenu() {

      let pdfPaysUrl, files = []
      if (this.pdfPays) {
        pdfPaysUrl = this.pdfPays.fields.file.url
        const responsePays = await fetch(pdfPaysUrl);
        const bufferPays = await responsePays.arrayBuffer();
        const pdfPays = new File([bufferPays], this.pdfPays.fields.file.fileName, {type: "application/pdf"});
        files.push(pdfPays);
      }

      // Share PDF file if supported.
      try {
        await navigator.share({files});
      } catch (err) {

        if (this.pdfPays) {
          window.open(pdfPaysUrl, '_blank');
        }
      }
    },
    nextStep() {
      this.updateBlock({
        id: this.block.sys.id,
        emotions: this.selectedEmotions
      })
      let emotions = []
      this.selectedEmotions.forEach(se => {
        emotions.push({
          capsule_id: this.newCapsule.contentful_id,
          user_id: this.currentUser.id,
          block_id: this.currentBlock.id,
          block_type: 'solution',
          name: se.name
        })
      })
      this.$http.post(`/capsules/${this.newCapsule.id}/emotions`, {
        emotion: emotions
      }).then(_ => {
        this.$emit('next-step', this.index)
      }).catch(console.error)
    },
    toggleEmotion(emotion) {
      if (this.selectedEmotions.find(el => el.id === emotion.id)) {
        this.selectedEmotions = this.selectedEmotions.filter(el => el.id !== emotion.id)
      } else {
        this.selectedEmotions.push(emotion)
      }
    },
    getId(url) {
      if (url.includes('shorts')) {
        let arr = url.split('/')
        let id = arr[arr.length - 1]
        return (id.length === 11)
            ? id
            : null;
      } else {
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        let match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
      }

    },

    createFrame() {
      if (!this.block.fields.video.includes('vimeo')) {

        if (this.$route.query.env) {
          const videoId = this.getId(this.block.fields.video);
          this.video = '<iframe allowfullscreen="allowfullscreen" src="//www.youtube.com/embed/'
              + videoId + '?rel=0;picture-in-picture=1&amp;accelerometer=1&amp;gyroscope=1&amp;autoplay=0" frameborder="0" style="border-radius: 16px;\n' +
              '    position: absolute;\n' +
              '    top: 0;\n' +
              '    bottom: 0;\n' +
              '    left: 0;\n' +
              '    width: 100%;\n' +
              '    height: 100%;\n' +
              '    border: 0;" ></iframe>';
        }
        this.videoId = this.getId(this.block.fields.video);
      }

    }
  },
  mounted() {
    if (typeof (YT) === 'undefined' || typeof (YT.Player) === 'undefined') {
      let tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      let firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    if (this.block.fields.video) {
      this.createFrame();
    }

    window.setTimeout(() => {
      this.readMore = this.$refs.content.getBoundingClientRect().height < 400
    }, 1000)


  },
  created() {
    this.isMobile = window.innerWidth < 799
    window.scrollTo(0, 0);

    if (this.currentBlock && this.currentBlock.emotions) {
      this.selectedEmotions = this.currentBlock.emotions
    }

  }
}
</script>

<style scoped lang="scss">

//fleche: parent =>
//fleche : transform:translateX(70px);

.head {
  --head-bg: #09A6E6;
  background: var(--head-bg);

}

.bubble {
  background: white;
  position: relative;
  z-index: 10;
  height: 70px;
  border-radius: 100%;
  transform: translateY(-50%);

  &.reverse {
    transform: rotate(180deg) translateY(50%);
  }
}

.triangle {
  position: absolute;
  bottom: -10px;
  left: calc(50% - 150px);
  display: inline-block;
  height: 0;
  width: 0;
  border-top: 20px solid white;
  border-right: 20px solid transparent;
  border-left: 20px solid transparent;
  transform: rotate(10deg);
}

.bubble-down {
  background: #09A6E6;
  position: relative;
  height: 70px;
  border-radius: 100%;
  transform: rotate(180deg) translateY(-40px);
  z-index: -1;
}

.triangle-down {
  position: absolute;
  bottom: -5px;
  right: calc(50% - 150px);
  display: inline-block;
  height: 0;
  width: 0;
  border-top: 20px solid #09A6E6;
  border-right: 20px solid transparent;
  border-left: 20px solid transparent;
}


.head-infos {
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.progress {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  height: 10px;
  width: 100%;
  position: relative;
}

.progress::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: var(--width);
  height: 100%;
  border-radius: 12px;
  background: white;
}

.icon-container img {
  width: 48px;
}

.info {
  display: grid;
  grid-template-columns: 90px 1fr;
  align-items: center;
  grid-gap: 20px;
}

.number-container {
  background: #E6F6FC;
  border-radius: 12px;
  padding: 20px 0;
  text-align: center;
  font-size: 20px;
  line-height: 26px;
  font-weight: bold;
  color: #09A6E6;
}

.content {
  position: relative;
  max-height: 400px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;


  &:before {
    z-index: 10;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 85%, white 100%);
  }

  &.active {
    max-height: none;

    &:before {
      display: none;
    }
  }
}

.emotion-icon {
  img {
    width: 32px;
  }
}

.emotion {
  padding: 12px;
  border: 2px solid #C4C8C9;
  position: relative;
  border-radius: 12px;
  cursor: pointer;

  &.selected {
    background: #E6F6FC;
    border: 2px solid #09A6E6;
    box-shadow: 0 2px 0 #09A6E6;
  }
}

.author-picture {
  width: 70px;
  height: 70px;
}

.footer {
  background: #09A6E6;
  padding-bottom: 48px;
  color: white;
}

.container-embed {
  border-radius: var(--radius-default);
  position: relative;
  width: 100%;
  height: 215px;


}

.journal-container {
  padding: 12px;
  border-radius: 12px;
  background: #F9F9F9;

  > div {
    display: flex;
    margin-bottom: 12px;
    gap: 12px;
    align-items: center;
  }

}

@include screen-m {
  .triangle-down {
    transform: translateY(10px);
  }
}
</style>